import { Container, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list";
import * as OrganizationUserQL from "queries/organization-user";
import * as Section from "@repoflow/components/section";

export const Sidebar = () => null;

// The section that owns this page draws the "Users" crumb, so there is nothing
// left for the list itself to add.
export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base, schema } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add User
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.domains.get.organizations.get.users"}
        query={OrganizationUserQL.list}
        variables={params}
        schema={schema}
        target={{ $ref: "/Public/OrganizationUsers" }}
        empty={"No users yet."}
        config={{
          "/Public/OrganizationUsers": {
            fields: ["email", "status", "createdAt"],
          },
        }}
        content={({ item: { email } }) => (
          <Link
            className={"btn btn-primary"}
            to={`${base}/${encodeURIComponent(email)}`}
          >
            View
          </Link>
        )}
      />
    </Container>
  );
};
